<template>
  <div class="error-message">
    <div class="em-icon">
      <fn-icon
        icon="alert"
        size="xs"
      />
    </div>
    <div class="em-content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-message {
  position: relative;
  display: flex;
  margin-top: math.div($space, 4);
  color: palette(orientation, red);
  font-size: map-get($font-sizes, 'm');

  .em-icon {
    margin-right: $pad * 0.5;
  }

  .icon {
    top: -2px;
  }
}
</style>
